// extracted by mini-css-extract-plugin
module.exports = {"root":"TutorialTipToggle_root__YZ0Mv","contents":"TutorialTipToggle_contents__1H_mj","checkbox":"TutorialTipToggle_checkbox__1GpOe"};